import React from 'react';
import { StyleSheet } from 'react-native';
import { rem } from 'design-system/values';
import { useAppSelector } from 'store/hooks';
import TouchableBounceCard from 'utils/packages/TouchableBounceCard';
import useShouldShowUpgrade from 'features/premium/hooks/useShouldShowUpgrade';
import { useBudgetingNavigate } from 'features/budgeting/hooks/useBudgetingNavigate';
import BudgetingCard from './BudgetingCard';
const BudgetingCardContainer = ({ style, disabled }) => {
    const thisMonth = useAppSelector((store) => store.feed.feed.cards.thisMonth);
    const { isUnlockedForSpace } = useShouldShowUpgrade({
        benefitId: 'budgeting',
    });
    const { onNavigate } = useBudgetingNavigate();
    return (<TouchableBounceCard onDark noMargin withPadding disabled={disabled} onPress={onNavigate} style={[styles.cardWrapper, style]}>
      <BudgetingCard thisMonth={isUnlockedForSpace ? thisMonth : undefined}/>
    </TouchableBounceCard>);
};
const styles = StyleSheet.create({
    cardWrapper: {
        flex: 1,
        flexGrow: 1,
        flexShrink: 1,
        marginStart: rem(4.5),
    },
});
export default BudgetingCardContainer;
